import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

export const NestedMenuItem = MenuItem;
export const NestedMenu = Menu;
export default NestedMenuItem;
